let util = {
    new_recruit_need: {
        uid: '',
        recruit_type_id: 0,
        recruit_job_id: 0,
        recruit_job_name: '',
        team_id: 0,
        fill_user_id: 0,
        fill_user: '',
        apply_user_id: 0,
        apply_user: '',
        office_id: 0,
        need_count: 1,
        exist_count: 0,
        wage_start: 0,
        wage_end: 0,
        recruit_reason: '',
        recruit_reason_detail: '',
        job_duty: '',
        job_require: '',
        remark: '',
        arrive_date: '',
    },
    reasons: [
        {label: '架构扩张', remark: '因业务扩张需增加人员'},
        {label: '人员替换', remark: '对该岗位人员进行替换'},
        {label: '工作调整', remark: '原岗位人员准备、或已经完成了岗位调整'},
        {label: '离职补充', remark: '原岗位人员已离职、或有离职风险'},
        {label: '其他', remark: ''},
    ],
    getDetail(id){
        return new Promise((resolve, reject)=>{
            Util.ajax.get(Util.api.recruit_need_detail, {
                params: {
                    id: id
                }
            }).then((response)=>{
                return response.data;
            }).then((res)=>{
                if(res.code === 1){
                    resolve(res.data);
                }else{
                    reject({message: res.msg});
                }
            }).catch((e)=>{
                reject(e);
            });
        });
    }
};

export default util;